import { createSlice, isAnyOf } from '@reduxjs/toolkit'

import {
  uploadAttachment,
  updateTicketStatus,
  refetchTicket,
} from 'api/tickets'

import {
  deleteTicketProviderTickets,
  reloadTicketProviderTicket,
} from 'api/ticketProviderTickets'

const initialState = {
  newAttachmentFileName: null,
  isAttachmentUploadError: false,
  isUpdating: false, // just for some operations like status update or ticket delete
  attachmentUploadInfo: {
    uploadFileName: null,
    uploadTotalBytes: 0,
    uploadCurrentBytes: 0,
  },
}

export const ticketSlice = createSlice({
  name: 'ticket',
  initialState,

  reducers: {
    selectAttachment: (state, { payload }) => {
      state.newAttachmentFileName = payload
      state.isAttachmentUploadError = false
    },

    abortAttachmentUpload: (state) => {
      state.newAttachmentFileName = null
      state.attachmentUploadInfo = {
        uploadFileName: null,
        uploadTotalBytes: 0,
        uploadCurrentBytes: 0,
      }
    },

    markAttachmentUploadAsFailed: (state) => {
      state.isAttachmentUploadError = true
    },

    updateAttachmentUploadProgress: (state, { payload }) => {
      state.attachmentUploadInfo = {
        uploadFileName: payload.uploadFileName || {},
        uploadTotalBytes: payload.uploadTotalBytes || 0,
        uploadCurrentBytes: payload.uploadCurrentBytes || 0,
      }
    },
  },

  extraReducers: (builder) => {
    builder
      // uploadAttachment received
      .addMatcher(
        uploadAttachment.matchFulfilled,
        (state, { payload }) => {
          const isError = Boolean(payload?.error)
          state.isAttachmentUploadError = isError
          state.attachmentUploadInfo = {
            uploadFileName: null,
            uploadTotalBytes: 0,
            uploadCurrentBytes: 0,
          }

          if (!isError) {
            state.newAttachmentFileName = null
          }
        }
      )

      // updateTicketStatus or other mutations requested
      .addMatcher(
        isAnyOf(
          updateTicketStatus.matchPending,
          refetchTicket.matchPending,
          deleteTicketProviderTickets.matchPending,
          reloadTicketProviderTicket.matchPending,
        ),
        (state) => {
          state.isUpdating = true
        }
      )

      // updateTicketStatus or other mutations received
      .addMatcher(
        isAnyOf(
          updateTicketStatus.matchFulfilled,
          refetchTicket.matchFulfilled,
          deleteTicketProviderTickets.matchFulfilled,
          reloadTicketProviderTicket.matchFulfilled,
        ),
        (state) => {
          state.isUpdating = false
        }
      )
  },
})


export const {
  selectAttachment,
  abortAttachmentUpload,
  markAttachmentUploadAsFailed,
  updateAttachmentUploadProgress,
  setIsUpdating,
} = ticketSlice.actions

export default ticketSlice.reducer
